import { createClient } from "@supabase/supabase-js";

// Supabase Auth for zebaa.uk. Customers and the website admin keep separate sessions (as before),
// so signing into the admin never signs a customer out and vice versa. The publishable key is
// designed to be public; the server checks every permission itself.
const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

export const supabaseConfigured = Boolean(url && key);

const client = (storageKey, detectSessionInUrl) =>
  createClient(url || "http://localhost", key || "missing", {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl, storageKey },
  });

// Email links (confirm, reset) land on customer pages, so only the shop client reads them from the URL.
export const shopAuth = client("zebaa-shop-auth", true);
export const adminAuth = client("zebaa-admin-auth", false);

const AUTH_ERRORS = [
  [/invalid login credentials/i, "Incorrect email or password."],
  [/email not confirmed/i, "Please confirm your email first - check your inbox for the link."],
  [/user already registered/i, "An account with this email already exists. Try signing in."],
  [/captcha/i, "Please complete the human verification and try again."],
  [/rate limit|too many/i, "Too many attempts. Please wait a minute and try again."],
  [/password should be at least/i, "Please choose a longer password."],
];

export function authMessage(error) {
  const msg = error?.message || String(error || "");
  const hit = AUTH_ERRORS.find(([re]) => re.test(msg));
  return hit ? hit[1] : msg || "Something went wrong. Please try again.";
}

// Staff (website admin) sign in with a username; each maps to an internal login address that is
// never a real mailbox. Must match STAFF_LOGIN_DOMAIN on the server.
const STAFF_LOGIN_DOMAIN = (process.env.REACT_APP_STAFF_LOGIN_DOMAIN || "staff.zebaa.uk").toLowerCase();
export const staffLoginEmail = (username) => `${username.trim().toLowerCase()}@${STAFF_LOGIN_DOMAIN}`;
